module.exports = __webpack_public_path__ + "static/media/bride.37acd809.png";